import React, { useEffect, useState } from "react";
import { Modal, Table, Spinner } from "react-bootstrap";
import { getSizeLogs } from "../../actions/product";

const SizeHistoryModal = ({ show, onHide, studentId, studentName }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && studentId) {
      fetchLogs();
    }
  }, [show, studentId]);

  const fetchLogs = async () => {
    setLoading(true);
    const data = await getSizeLogs(studentId);
    setLogs(data);
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Size History - {studentName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : logs.length === 0 ? (
          <p className="text-center py-4">No size history found.</p>
        ) : (
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Old Size</th>
                  <th>New Size</th>
                  <th>Updated By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>{log.product?.display_name || log.product?.name}</td>
                    <td><span className="badge bg-secondary">{log.oldSize || "N/A"}</span></td>
                    <td><span className="badge bg-success">{log.newSize}</span></td>
                    <td>{log.updatedBy}</td>
                    <td>{new Date(log.updatedAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SizeHistoryModal;
